import { useFormContext, useWatch } from 'react-hook-form';
import { ALIGNMENT } from 'ui/selects';
import { Subtitle2 } from 'ui/theme';
import { Moment } from 'moment';
import { useEffect, useMemo } from 'react';
import { match } from 'ts-pattern';
import { useStartNodeContext } from '../../StartNodeEditor.context';
import { SCHEDULE_RECURRENCE_TEST_ID, SCHEDULE_RECURRENCE_OPTIONS } from './Scheduler.constants';
import { RecurrenceScheduleType } from './Scheduler.types';
import {
  RecurrenceSelect,
  RowWrapper,
  RecurrenceSelectOptionsContainer,
} from './SchedulerForm.styled';

const getRecurrenceOptions = (startDate: Moment) => {
  const day = startDate?.format('dddd');

  return SCHEDULE_RECURRENCE_OPTIONS.map((option) => {
    const getOptionWithDay = () => ({ ...option, label: `${option.label} on ${day}s` });

    return match(option.id)
      .with(RecurrenceScheduleType.Weekly, getOptionWithDay)
      .with(RecurrenceScheduleType.BiWeekly, getOptionWithDay)
      .otherwise(() => option);
  });
};

export const Recurrence = () => {
  const { isReadOnly } = useStartNodeContext();
  const [startDate, recurrence] = useWatch({ name: ['startDate', 'recurrence'] });
  const options = useMemo(() => getRecurrenceOptions(startDate), [startDate]);
  const { trigger } = useFormContext();

  useEffect(() => {
    // validate recurDays anytime recurrence changes
    trigger('recurDays');
  }, [recurrence]);

  return (
    <div data-test={SCHEDULE_RECURRENCE_TEST_ID}>
      <Subtitle2>Repeat</Subtitle2>
      <RowWrapper>
        <RecurrenceSelect
          name="recurrence"
          id="recurrence-options"
          title="recurrence-options"
          options={options}
          verticalAlignment={ALIGNMENT.DOWN}
          isDisabled={isReadOnly}
          isReadOnly={isReadOnly}
          SelectOptionsContainer={RecurrenceSelectOptionsContainer}
        />
      </RowWrapper>
    </div>
  );
};
